export default __webpack_public_path__ + "static/media/sn.07ec7ccb.svg";